import { Text } from '@dbi-tools/ui-kit';
import { A } from '@dbi-tools/ui-kit/lib/link';
import React, { Fragment } from 'react';

import { DAVIDS_URL } from '../../service/variables';

const PrivacyPolicyText: React.FC = () => {
  return (
    <Fragment>
      <Text measure="xxs" color="gray500">
        By clicking Continue, I agree that the information I provide to David’s Bridal will be used to create an account
        and will be subject to the David’s Bridal&nbsp;
        <A
          href={`${DAVIDS_URL}/Content_Legal_terms?utm_source=planning-tools&utm_medium=landing`}
          target="_blank"
          rel="noreferrer noopener"
        >
          Terms and Conditions
        </A>
        &nbsp;and&nbsp;
        <A
          href={`${DAVIDS_URL}/Content_Legal_privacy?utm_source=planning-tools&utm_medium=landing`}
          target="_blank"
          rel="noreferrer noopener"
        >
          Privacy Policy
        </A>
      </Text>
      <Text measure="xxs" color="gray500">
        This site is protected by reCAPTCHA and the Google&nbsp;
        <A href="https://policies.google.com/privacy" target="_blank" rel="noreferrer noopener">
          Privacy Policy
        </A>
        &nbsp;and&nbsp;
        <A href="https://policies.google.com/terms" target="_blank" rel="noreferrer noopener">
          Terms of Service
        </A>
        &nbsp;apply.
      </Text>
    </Fragment>
  );
};

export default PrivacyPolicyText;
